import React from 'react';

const Spinner = () => (
  <div className="spinner rounded-full">
    <img src="/loading.gif" alt="Loading..." />
  </div>
);

export default Spinner;